import { Container, Point, Sprite, Text, TextStyle } from "pixi.js";
import { HBox } from "../../../common/components/ui/HBox";
import { BuildingUpgradeItemResourcePackage } from "../resources/BuildingUpgradeItemResourcePackage";
import { GameFont } from "../../../common/GameFont";
import { DropShadowFilter } from "pixi-filters";
import { StringFormatExtention } from "by/gamefactory/extensions/StringFormatExtention";

export class BuildingUpgradeItemLandlordRewardComponent extends Container {
    private static readonly YOU_JUST_GOT_TEXT = 'YOU JUST GOT REWARDED WITH';
    private static readonly FOR_YOUR_TEXT = 'FOR YOUR UPGRADE';

    private topText: Text;
    private rewardValue: Text;
    private rewardIcon: Sprite;
    private rewardBox: HBox;
    private bottomText: Text;

    public constructor(
        itemUpgradeResources: BuildingUpgradeItemResourcePackage,
        rewardValue: string
    ) {
        super();
        this.topText = new Text(BuildingUpgradeItemLandlordRewardComponent.YOU_JUST_GOT_TEXT, new DescriptionTextStyle());

        this.rewardBox = new HBox(15);
        const rewardFilter = new DropShadowFilter({
            offset: new Point(0, 0),
            blur: 30,
            color: 0x0085FF,
            quality: 4.5,
            alpha: 1,
            pixelSize: 0.6
        });
        this.rewardBox.filters = [rewardFilter];
        let formattedTokenAmount: string;
        const tokenAmount = parseFloat(rewardValue);
        if (Number.isInteger(tokenAmount)) {
            formattedTokenAmount = StringFormatExtention.formatWithComma(tokenAmount.toString());
        } else {
            const fixedTokenAmount = tokenAmount.toFixed(4);
            formattedTokenAmount = StringFormatExtention.formatWithComma(parseFloat(fixedTokenAmount).toString());
        }
        this.rewardValue = new Text(formattedTokenAmount, new RewardTextStyle());
        this.rewardIcon = new Sprite(itemUpgradeResources.assets_views_building_upgrade_item_token_png);
        this.rewardBox.addChild(this.rewardValue, this.rewardIcon);

        this.bottomText = new Text(BuildingUpgradeItemLandlordRewardComponent.FOR_YOUR_TEXT, new DescriptionTextStyle());

        this.addChild(
            this.topText,
            this.rewardBox,
            this.bottomText
        );

        this.layout();
    }

    private layout(): void {
        this.topText.position.set(1, 11);
        this.rewardBox.position.set(this.topText.x + this.topText.width * 0.5 - this.rewardBox.width * 0.5, 138);
        this.rewardIcon.position.y = -36;
        this.bottomText.position.set(109, 330);
    }
}

class DescriptionTextStyle extends TextStyle {
    public constructor() {
        super({
            fontFamily: GameFont.DEFAULT_FONT,
            fontSize: 64,
            fill: '#FFFFFF'
        });
    }
}

class RewardTextStyle extends DescriptionTextStyle {
    public constructor() {
        super();
        this.fontSize = 156;
        this.letterSpacing = 0.5;
    }
}